import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProductsAndPagesCourseBuilderLockBoldSmallIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M17.684 10.386V7.623c0-3.107-2.545-5.625-5.684-5.625-3.14 0-5.684 2.518-5.684 5.625v2.763C4.9 11.088 4.006 12.517 4 14.083v3.75c.002 2.3 1.886 4.165 4.21 4.167h7.58c2.324-.002 4.208-1.866 4.21-4.167v-3.75c-.006-1.566-.901-2.995-2.316-3.697zm-4 5.324c0 .92-.754 1.667-1.684 1.667-.93 0-1.684-.747-1.684-1.667s.754-1.667 1.684-1.667c.93 0 1.684.746 1.684 1.667zM12 4.083c1.975.002 3.576 1.586 3.579 3.54V9.5c0 .23-.189.416-.421.416H8.842c-.232 0-.42-.186-.42-.416V7.623C8.423 5.67 10.024 4.085 12 4.083z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ProductsAndPagesCourseBuilderLockBoldSmallIcon = __decorateClass([
  customElement("elm-products-and-pages-course-builder-lock-bold-small-icon")
], ProductsAndPagesCourseBuilderLockBoldSmallIcon);
export { ProductsAndPagesCourseBuilderLockBoldSmallIcon };
